import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStoreService {

  private sessionWarningShown: boolean = false;
  private warningTime: number = 1 * 60 * 1000;
  private expirationTimeSubject = new BehaviorSubject<Date | null>(null);
  public expirationTime$ = this.expirationTimeSubject.asObservable();

  constructor(private router: Router, private userService: UserService) {}

  private getExpirationTime(token: string): Date | null {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error("Invalid JWT token format.");
      return null;
    }
    const payload = parts[1];
    const decodedPayload = JSON.parse(atob(payload));
    const exp = decodedPayload.exp;
    return exp ? new Date(exp * 1000) : null;
  }

  public setSessionExpiration(token: string, sessionExpirationTimeInSeconds: number): void {
    const expirationTime = this.getExpirationTime(token);
    if (expirationTime) {
      this.expirationTimeSubject.next(expirationTime);
      const expireAt = expirationTime.getTime();
      const timeLeft = expireAt - Date.now();

      this.sessionWarningShown = false;

      if (timeLeft <= this.warningTime && !this.sessionWarningShown) {
        this.showSessionWarning(timeLeft);
      }

      setTimeout(() => {
        if (!this.sessionWarningShown) {
          this.showSessionWarning(timeLeft);
        }
      }, timeLeft - this.warningTime);
    }
  }
  private showSessionWarning(timeLeft: number): void {
    const warningTimeInSeconds = Math.floor(timeLeft / 1000);
    const minutesLeft = Math.floor(warningTimeInSeconds / 60);

    const userChoice = confirm(`Your session will expire in ${minutesLeft} minute(s). Do you want to continue or log out?`);

    if (userChoice) {
      this.extendSession();
    } else {
      this.logout();
    }

    this.sessionWarningShown = true;
  }



  public extendSession(): void {

    this.sessionWarningShown = false;
    const authData = localStorage.getItem('auth');

    if (authData) {
      const parsedAuthData = JSON.parse(authData);
      const refreshToken = parsedAuthData.token;

      if (refreshToken) {
        this.userService.refreshToken({ RefreshToken: refreshToken }).subscribe(
          (response: any) => {
            const newToken = response.token;
            localStorage.setItem('auth', JSON.stringify({
              ...parsedAuthData,
              token: newToken
            }));
            this.setSessionExpiration(newToken, 300);
          },
          (error: any) => {
            console.error('Error refreshing session:', error);
            this.logout();
          }
        );
      } else {
        console.error('No refresh token found.');
        this.logout();
      }
    } else {
      console.error('No auth data found in localStorage.');
      this.logout();
    }
  }

  public logout(): void {
    this.router.navigate(['/']);
  }
}
